import { Box, InputAdornment } from '@mui/material';
import { ReactComponent as SearchIcon } from 'assets/icons/search.svg';
import { useTranslation } from 'react-i18next';
import { RootStyle } from './SearchBox.style';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { setSearchText } from 'redux/slices/app/appSlice';
import { SearchBoxProps } from './SearchBox.type';
import { useEffect, useState } from 'react';
import useDebounce from 'hooks/useDebounce';
import { GlobalVariables } from 'config/constant';

function SearchBox({
  searchPlaceholder,
  searchText,
  disabled,
  disableGlobalSearch,
  onChange,
  updateBySearchText,
}: SearchBoxProps) {
  const [text, setText] = useState(searchText || '');
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const globalSearchText = useAppSelector((state) => state.appReducer.navBarConfig.searchText);
  const debouncedText = useDebounce(text, GlobalVariables.DebounceTime.Short);

  useEffect(() => {
    if (!disableGlobalSearch) dispatch(setSearchText(text));
  }, [debouncedText, disableGlobalSearch]);

  useEffect(() => {
    if (globalSearchText?.length >= 0 && globalSearchText !== text && !disableGlobalSearch) {
      setText(globalSearchText);
    }
  }, [globalSearchText]);

  useEffect(() => {
    if (updateBySearchText) setText(searchText);
  }, [searchText, updateBySearchText]);

  return (
    <Box width="90%">
      {searchPlaceholder && (
        <RootStyle
          variant="standard"
          placeholder={t(searchPlaceholder)}
          value={text}
          onChange={(e) => {
            setText(e.target.value);
            onChange?.(e.target.value);
          }}
          InputProps={{
            disableUnderline: true,
            sx: {
              height: 50,
            },
            startAdornment: (
              <InputAdornment
                position="start"
                sx={{
                  marginLeft: 1,
                }}
              >
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          disabled={disabled}
        />
      )}
    </Box>
  );
}

export default SearchBox;
